module.exports = __webpack_public_path__ + "assets/16e2cc258b6c3ce1e2dbfbd3a9db28fb.svg";